import { Div, Collection, ComponentBase } from '@tblabs/truffle';
import { SelectableCollection } from './SelectableCollection';
import { SelectableItem } from './SelectableItem';
import { SnapBox } from './SnapBox';
import { Snap } from '../../Models/Snap';


export class SafeCollectionPrinter<T> extends Div
{
    constructor(data: Collection<T>, printer: (item: T) => ComponentBase<any>, options: { reverse?: boolean } = {})
    {
        super();

        let itemToComponent = new Map<T, ComponentBase<any>>();

        data.OnAdd((items: T[]) =>
        {
            for (const item of items)
            {
                const pr = printer(item);

                if (options.reverse == true)
                    this.Prepend(pr);
                else
                    this.Append(pr);

                itemToComponent.set(item, pr);
            }
        });

        data.OnRemove((item: T) =>
        {
            itemToComponent.get(item)?.RemoveSelf();
        });
    }
}


export class SnapshotsBox extends Div
{
    constructor(snaps: SelectableCollection<Snap>)
    {
        super("snapshots-collection");

        this.Append(
            new SafeCollectionPrinter(snaps, (snap: SelectableItem<Snap>) => new SnapBox(snap), { reverse: true })
        );
    }
}
